export default __webpack_public_path__ + "static/media/pantry2-before2-1440w.96b88e49.png";